import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import LandingPage from "../../landing"
import CompanyProfile from "../../company-profile"
import ScreenHeader from "../../utility/ScreenHeader"
import CompanySearchResults from "../../explore/company-search-results"

const Stack = createStackNavigator()

const DashboardStack = () => {
  return (
    <Stack.Navigator screenOptions={{ gestureEnabled: false }} id={undefined}>
      <Stack.Screen
        name="DashboardHome"
        component={LandingPage}
        options={{
          title: 'Dashboard',
          header: function DashboardHeader() {
            return (
              <ScreenHeader
                goBackEnabled={false}
                functionality="settings"
              />
            )
          }
        }}
      />
      <Stack.Screen
        name="CompanySearchResults"
        component={CompanySearchResults}
        options={{
          title: "Search Results",
          header: function CompanySearchResultsHeader() {
            return (
              <ScreenHeader
                title="Search Results"
                goBackEnabled
                functionality="search-company"
              />
            )
          }
        }}
      />
      <Stack.Screen
        name="Company"
        component={CompanyProfile}
        options={({ route }: any) => ({
          header: function CompanyProfileHeader({options}: any) {
            return (
              <ScreenHeader
                title={options.title || route.params?.company?.name || route.params?.name}
                goBackEnabled
                functionality="search-company"
              />
            )
          },
        })}
      />
    </Stack.Navigator>
  )
}

export default DashboardStack


